export default __webpack_public_path__ + "static/media/featured-listing.60cbdb8f.png";